import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function BackToTop() {
    const { gtm } = useGlobal();
    const [showIcon, setShowIcon] = useState(false);

    const handleToTop = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            button_name: 'Back to top',
            list_name: 'none',
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const initShowIcon = () => setShowIcon(window.pageYOffset > 100);
            initShowIcon();
            window.addEventListener('scroll', initShowIcon);
            return () => window.removeEventListener('scroll', initShowIcon);
        }
    }, []);

    return (
        <div className={`back-to-top ${showIcon ? 'show' : 'hide'} ${css['back-to-top']}`} onClick={handleToTop}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g id="icon24/top">
                    <path
                        id="Vector"
                        d="M12 20.5V6M12 6L6.71191 11.4306M12 6L17.2119 11.4306"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path id="Line 3" d="M6 4H18" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                </g>
            </svg>
        </div>
    );
}
